import { FormGroup } from '@angular/forms';

export enum DatepickerStartView {
  MONTH = 'month',
  YEAR = 'year',
  MULTI_YEAR = 'multi-year'
}

export interface IDatepickerSchema {
  label?: string;
  placeholder?: string;
  required?: boolean;
  value?: Date;
  startView?: DatepickerStartView,
  min?: Date;
  max?: Date;
  formControlName?: string;
  formGroup?: FormGroup;
  panelClass?: string | string[];
}

export const defaultDatepickerSchema: IDatepickerSchema = {
  label: 'Data',
  placeholder: 'Selecione a data',
  required: false,
  value: new Date(),
  min: new Date('1900-1-1'),
  max: new Date('2099-12-31')
};
